// Globaler Store für laufende Serien-Jobs (Buchen/Löschen) — 08/2026 Phase 2.
// Hält die series_ids aktiver Jobs, persistiert in localStorage (übersteht
// Reload) und benachrichtigt Abonnenten (Fortschrittskarten).
const KEY = 'sf_active_series_jobs';
const listeners = new Set();

function read() {
  try {
    return new Set(JSON.parse(localStorage.getItem(KEY) || '[]'));
  } catch (_) {
    return new Set();
  }
}
function write(set) {
  try {
    localStorage.setItem(KEY, JSON.stringify([...set]));
  } catch (_) { /* noop */ }
}

let ids = read();

function emit() {
  const arr = [...ids];
  for (const cb of listeners) {
    try { cb(arr); } catch (_) { /* noop */ }
  }
}

export function getSeriesJobs() {
  return [...ids];
}

export function addSeriesJob(seriesId) {
  if (!seriesId || ids.has(seriesId)) return;
  ids.add(seriesId);
  write(ids);
  emit();
}

export function removeSeriesJob(seriesId) {
  if (!ids.has(seriesId)) return;
  ids.delete(seriesId);
  write(ids);
  emit();
}

export function subscribeSeriesJobs(cb) {
  listeners.add(cb);
  cb([...ids]);
  return () => listeners.delete(cb);
}
